import { useTranslation } from "next-i18next";

import BlogCard from "./BlogCard";

const OtherBlogs = ({ blogs }) => {
  const { t } = useTranslation();

  return (
    <section>
      <h3 className="mb-[24px] font-poppins text-[24px] font-semibold md:text-[30px]">
        {t("blog:blog-read-other-blogs")}
      </h3>
      <ul className="grid grid-cols-1 gap-[24px] md:grid-cols-3">
        {blogs?.map(blog => {
          return <BlogCard key={blog.id} blog={blog} />;
        })}
      </ul>
    </section>
  );
};

export default OtherBlogs;
